module.exports = __webpack_public_path__ + "img/c01_unitstartechhoplitechampion_Normal_ua.ef636854.webp";